const state = {
  isRepAuthenticated: false,
  landingInfo: null,
  landingUrl: null,
  repInfo: null,
  groupInfo: null,
  isEmployeeEnrollment:false,
  isContinueEnrollmentLandingPage: false,
  isPatriotOver65: false,
  repCode: null,
  isGroupViewPlans: false,
  agentGroupLandingInfo: {},
  showDefaultImage: true,
  innerLandingUrl: '',
  isHomePageRedirect: false,
  showReferral: false,
  isReferralRender: false,
  referralCode: '',
  themeColorList: []
}

const mutations = {
  setRepAuthenticatedState: (state, payload) => {
    state.isRepAuthenticated = payload
  },
  setLandingInfo: (state, payload) => {
    state.landingInfo = payload
  },
  setLandingUrl: (state, payload) => {
    state.landingUrl = payload
  },
  setRepInfo: (state, payload) => {
    state.repInfo = payload
  },
  setGroupInfo: (state, payload) => {
    state.groupInfo = payload
  },
  setEmployeeEnrollmentState: (state, payload) => {
    state.isEmployeeEnrollment = payload
  },
  setContinueEnrollmentFlag: (state, payload) => {
    state.isContinueEnrollmentLandingPage = payload
  },
  setPatriotAgeStatus: (state, payload) => {
    state.isPatriotOver65 = payload
  },
  setRepCode: (state, payload) => {
    state.repCode = payload
  },
  setGroupViewPlans: (state, payload) => {
    state.isGroupViewPlans = payload
  },
  setAgentGroupLandingInfo: (state, payload) => {
    state.agentGroupLandingInfo = payload
  },
  setDefaultImageStatus: (state, payload) => {
    state.showDefaultImage = payload
  },
  setInnerLandingInfo: (state, payload) => {
    state.innerLandingUrl = payload
  },
  setHomePageRedirect: (state, payload) => {
    state.isHomePageRedirect = payload
  },
  setThemeColor: (state, payload) => {
    state.themeColorList = payload
  },
  setShowReferral: (state, payload) => {
    state.showReferral = payload
  },
  setReferralLoadStatus: (state, payload) => {
    state.isReferralRender = payload
  },
  setReferralCode: (state, payload) => {
    state.referralCode = payload
  }
}

const actions = {
  isEmployeeEnrollment: ({commit}, payload) => {
    commit('setEmployeeEnrollmentState', payload)
  },
  isRepAuthenticated: ({commit}, payload) => {
    commit('setRepAuthenticatedState', payload)
  },
  landingInfo: ({commit}, payload) => {
    commit('setLandingInfo', payload)
  },
  landingUrl: ({commit}, payload) => {
    commit('setLandingUrl', payload)
  },
  repInfo: ({commit}, payload) => {
    commit('setRepInfo', payload)
  },
  groupInfo: ({commit}, payload) => {
    commit('setGroupInfo', payload)
  },
  continueEnrollmentInfo: ({commit}, payload) => {
    commit('setContinueEnrollmentFlag', payload)
  },
  isPatriotOver65: ({commit}, payload) => {
    commit('setPatriotAgeStatus', payload)
  },
  repCode: ({commit}, payload) => {
    commit('setRepCode', payload)
  },
  isGroupViewPlans: ({commit}, payload) => {
    commit('setGroupViewPlans', payload)
  },
  agentGroupLandingInfo: ({commit}, payload) => {
    commit('setAgentGroupLandingInfo', payload)
  },
  showDefaultImage: ({commit}, payload) => {
    console.log('showDefaultImage', payload)
    commit('setDefaultImageStatus', payload)
  },
  innerLandingUrl: ({commit}, payload) => {
    commit('setInnerLandingInfo', payload)
  },
  isHomePageRedirect: ({commit}, payload) => {
    commit('setHomePageRedirect', payload)
  },
  themeColorList: ({commit}, payload) => {
    commit('setThemeColor', payload)
  },
  showReferral: ({commit}, payload) => {
    commit('setShowReferral', payload)
  },
  isReferralRender: ({commit}, payload) => {
    commit('setReferralLoadStatus', payload)
  },
  referralCode: ({commit}, payload) => {
    commit('setReferralCode', payload)
  }
}

export default {
  state,
  mutations,
  actions
}
